import { makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const PREFIX = 'styles';

const classes = {
  mainContainer: `${PREFIX}-mainContainer`
};

export const useWaterfallCalculatorStyles = makeStyles<ITheme>(() => ({
  [`& .${classes.mainContainer}`]: {
    width: '100%',
    minWidth: 'fit-content',
  }
}));

export const useNumberFormattedFiedStyles = makeStyles<ITheme>(theme => ({
  equityValueInput: {
    width: 160,
    marginLeft: '0.875rem'
  },
}));
